<template>
 
</template>

<script>

export default {
  title: "New",
  access_code: "L_FORM01",
  created() {
      this.$router.push("/FORMS/ClaimForm/request")
  }
};
</script>

<style>
</style>